var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { content: "Nivel de discapacidad:", "has-line": "" }
      }),
      _c("div", { staticClass: "bg-secondary-3 p-2 rounded" }, [
        _c(
          "div",
          { staticClass: "bg-white p-3 rounded border" },
          [
            _vm._m(0),
            _vm._l(_vm.value, function(item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "row align-items-center my-2 py-2"
                },
                [
                  _c("div", { staticClass: "col-md" }, [
                    _vm._v(_vm._s(item.min) + " - " + _vm._s(item.max))
                  ]),
                  _c("div", { staticClass: "col-md" }, [
                    _c(
                      "span",
                      {
                        staticClass: "rounded-pill py-1 px-3 text-semibold",
                        style: _vm.badge(item.color)
                      },
                      [_vm._v(" " + _vm._s(_vm._f("empty")(item.name)) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col-md-5" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(item.description)) + " "
                    )
                  ])
                ]
              )
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row align-items-center text-bold" }, [
      _c("div", { staticClass: "col-md" }, [
        _c("span", { staticClass: "text-semibold" }, [
          _vm._v("Porcentaje Ponderado")
        ])
      ]),
      _c("div", { staticClass: "col-md" }, [
        _c("span", { staticClass: "text-semibold" }, [
          _vm._v("Nivel de Discapacidad")
        ])
      ]),
      _c("div", { staticClass: "col-md-5" }, [
        _c("span", { staticClass: "text-semibold" }, [
          _vm._v("Interpretación General")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }